export const PERMISSION = {
  write: 'w',
  read: 'r',
};
